import { Box, Typography, Button, Chip, styled } from "@mui/material";
import Image from "@/components/image";
import CongratsIcon from "@/assets/illustrations/success.gif";
import { celebrationButtonSx } from "../styles";

const Name = styled(Typography)({
  fontFamily: "Proxima Nova",
  fontWeight: "700",
  fontSize: "20px",
  lineHeight: "30px",
  color: "text.primary",
  paddingLeft: "8px",
});

const ClusterIcon = styled(Image)({
  width: "24px",
  height: "24px",
  marginRight: "10px",
});

type ClusterSectionProps = {
  cluster: { name: string; icon?: { url: string } };
  onAdvance: () => void;
  isLast: boolean;
};

export const ClusterSection = ({
  cluster,
  onAdvance,
  isLast,
}: ClusterSectionProps) => (
  <Box
    sx={{
      textAlign: "center",
      padding: "48px 24px 24px 24px",
      borderRadius: "16px",
      backgroundColor: "#fff",
      display: "flex",
      minWidth: "580px",
      maxWidth: "95%",
      flexDirection: "column",
      gap: "32px",
      alignItems: "center",
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "center",
      }}
    >
      <Typography
        color="black.main"
        variant="h3"
        fontFamily="Nunito"
        fontWeight="700"
      >
        Cluster Completed
      </Typography>
      <Image
        alt="cluster completion celebration"
        src={CongratsIcon}
        sx={{ width: "144px", height: "144px" }}
      />
      <Typography
        variant="h6"
        fontFamily="Proxima Nova"
        fontWeight="600"
        color="text.primary"
      >
        You&apos;ve explored
      </Typography>
      <Chip
        icon={<ClusterIcon src={cluster?.icon?.url} alt={cluster.name} />}
        label={<Name>{cluster.name}</Name>}
        sx={{
          pointerEvents: "none",
          backgroundColor: "rgba(145, 158, 171, 0.12)",
          borderRadius: "10px",
          height: "32px",
          paddingX: "4px",
          "& .MuiChip-label": {
            fontFamily: "Proxima Nova",
            fontWeight: "700",
            fontSize: "20px",
            lineHeight: "30px",
            color: "text.primary",
            paddingX: "8px",
          },
          "& .MuiChip-icon": { marginLeft: "4px", marginRight: "-8px" },
        }}
      />
      <Typography
        variant="h6"
        fontFamily="Proxima Nova"
        fontWeight="600"
        color="text.primary"
      >
        Look at you go...
      </Typography>
    </Box>
    <Button
      color="primary"
      variant="contained"
      sx={{ ...celebrationButtonSx, width: "100%" }}
      onClick={onAdvance}
    >
      {isLast ? "Keep Climbing" : "Next"}
    </Button>
  </Box>
);
